import { Collapsible, Skeleton } from "@biblioteksentralen/react";
import { Suspense } from "react";
import { SearchInput } from "../../../searchAndCollection/components/search/SearchInput";
import { useIsOnSearchPage } from "../../../searchAndCollection/hooks/useIsOnSearchPage";
import { useIsFrontPage } from "../../../utils/hooks/useIsFrontPage";
import { useSitePalette } from "../../../utils/useSitePalette";

export const SearchInputWrapper = () => {
  const isSearchPage = useIsOnSearchPage();
  const isFrontPage = useIsFrontPage();
  const paletteColors = useSitePalette().colors;

  return (
    <Suspense
      fallback={
        <Skeleton
          height="7rem"
          css={{
            "--start-color": paletteColors.search.css.background,
            "--end-color": paletteColors.card.css.background,
          }}
        />
      }
    >
      <Collapsible.Root open={isFrontPage || isSearchPage} unmountOnExit>
        <Collapsible.Content>
          <SearchInput />
        </Collapsible.Content>
      </Collapsible.Root>
    </Suspense>
  );
};
